export const ImageSchema = `
  largeImageOnlineURL
  mediumImageOnlineURL
  smallImageOnlineURL
`;
